







import { Component, Vue } from 'vue-property-decorator';
import { utils } from '@easygenerator/fragment-sdk';
import ToastNotification from '@/components/common/ToastNotification.vue';

@Component({
  metaInfo(this: App) {
    return {
      htmlAttrs: { lang: this.translationManager.getCurrentLocale() }
    };
  },
  components: { ToastNotification }
})
export default class App extends Vue {
  translationManager = utils.TranslationManager.getInstance();
}
